const translations = {
  common: {
    logo: "KOON-SERVICE",
    viewService: "View service",
    explore: "Explore services",
    contactHelp: "Contact us for support",
    contactButton: "Contact us",
    footer: "© 2026 Koon-Service. All rights reserved. พัฒนาโดย นักศึกษาสาขาเทคโนโลยีดิจิทัลและสารสนเทศ ระดับปริญญาตรี",
    phone: "Phone: 062-428-3696",
    line: "Line: @koon_s",
    email: "E-mail: kvs_service@koonservice.com",
    hours: "Every day: 8:00 AM - 5:00 PM",
  },
  nav: {
    home: "Home",
    services: "Services",
    about: "About",
    contact: "Contact",
  },
  language: {
    th: "TH 🇹🇭",
    en: "EN 🇺🇸",
    lo: "LA 🇱🇦",
    mm: "MM 🇲🇲",
  },
  hero: {
    subtitle: "Professional IT solutions for your business",
    cta: "Explore the company",
  },
  home: {
    servicesTitle: "Our Services",
    whyTitle: "Why choose us",
    why: [
      {
        title: "Fast",
        desc: "We provide fast service to reduce downtime and keep your business running smoothly.",
      },
      {
        title: "Professional",
        desc: "Our team has over 5 years of IT experience and solves problems with efficiency.",
      },
      {
        title: "High Quality",
        desc: "We follow international standards to keep your systems stable, secure, and reliable.",
      },
    ],
    contactTitle: "Contact",
    address1: "Koon Service Co., Ltd.\n329 Moo 10 Main Road, Bang Sao Thong, Bang Sao Thong District, Samut Prakan 10570",
    address2: "Koon Service Co., Ltd.\n18 Soi Lasalle 65, Bang Na Tai, Bang Na, Bangkok 10260",
  },
  services: {
    itService: "IT Service",
    cctv: "CCTV",
    equipment: "IT Equipment",
    network: "NETWORK",
  },
  itService: {
    title: "IT Service",
    introTitle: "IT service for organizations",
    introText: "We provide experienced IT outsourcing engineers for installation, troubleshooting, and system maintenance so your organization can work continuously and efficiently.",
    detailTitle: "Scope of Services",
    pointsLeft: [
      "Install computer systems and networks",
      "Inspect and fix hardware/software issues",
      "Maintain servers and internal systems",
      "User support (Helpdesk)",
      "Set up WiFi and LAN systems",
    ],
    pointsRight: [
      "IT system maintenance",
      "Security and firewall management",
      "Data backup",
      "24/7 system monitoring",
      "IT consulting",
    ],
    problemsTitle: "If you are facing these issues",
    ctaContact: "Contact us for support",
    cards: [
  {
    title: "Too many projects",
    desc: "Need more technicians to support projects",
  },
  {
    title: "Can't find technicians",
    desc: "Unable to find skilled technicians",
  },
  {
    title: "Can't manage the team",
    desc: "Unable to manage a large team efficiently",
  },
  {
    title: "Limited budget",
    desc: "Unable to hire more full-time employees",
  },
],
  },

  cctv: {
    title: "CCTV & SECURITY",
    introTitle: "CCTV installation and maintenance services",
    introText: "We design, install, and maintain CCTV systems and full security solutions for organizations, offices, factories, and businesses with a professional team.",
    detailTitle: "Scope of Services",
    pointsLeft: [
      "Design and install CCTV systems for your space",
      "Install IP and analog cameras",
      "Lay cabling and network equipment",
      "Set up NVR/DVR recording devices",
      "Configure mobile and internet viewing",
    ],
    pointsRight: [
      "Maintain CCTV systems",
      "Inspect and fix camera issues",
      "Upgrade existing systems",
      "Security system consulting",
      "Monthly maintenance services",
    ],
    problemsTitle: "If you are facing these issues",
    cards: [
      { title: "Blurry footage", desc: "Images are not sharp or visible at night." },
      { title: "Incorrect installation", desc: "Camera angles do not cover key areas." },
      { title: "Unstable system", desc: "Cameras disconnect often or cannot playback recordings." },
      { title: "No system monitoring", desc: "No team is available to manage issues." },
    ],
    ctaContact: "Contact us for support",
  },
  equipment: {
    title: "IT Equipment",
    introTitle: "Complete IT equipment supply and installation",
    introText: "We supply and install IT equipment for organizations, including computers, servers, network devices, and office systems, with advice on the right equipment for your business.",
    detailTitle: "Scope of Services",
    pointsLeft: [
      "Supply PCs and notebooks",
      "Supply routers, switches, and access points",
      "Supply servers and storage devices (NAS)",
      "Office equipment such as printers and scanners",
      "Accessories like UPS, racks, and cables",
    ],
    pointsRight: [
      "Install and configure equipment",
      "Design network systems for organizations",
      "Install servers and backup systems",
      "Advise on the best equipment for your work",
      "After-sales support and maintenance",
    ],
    cards: [
      { title: "Outdated equipment", desc: "Slow computers or systems that do not support new work." },
      { title: "Wrong equipment choice", desc: "Bought devices that do not meet your needs." },
      { title: "Unstable systems", desc: "Devices fail often and affect work." },
      { title: "No support team", desc: "No IT team to maintain and fix problems." },
    ],
    ctaTitle: "Need IT equipment for your organization?",
    ctaText: "Speak with an expert to design a system that fits your business.",
    ctaContact: "Contact us to purchase equipment",
    ctaContactText: "Contact us for support",
    featuredProducts: "Recommended Items"

  },
  network: {
    title: "NETWORK & SECURITY",
    introTitle: "Network and security system installation",
    introText: "We design, install, and maintain network and security systems for organizations of all sizes to ensure stable, secure communication and support future growth.",
    detailTitle: "Scope of Services",
    pointsLeft: [
      "Install LAN and WiFi networks within organizations",
      "Install routers, switches, and access points",
      "Design network architecture for your organization",
      "Set up VLANs and manage traffic",
      "Connect internet and cloud services",
    ],
    pointsRight: [
      "Install firewalls to prevent attacks",
      "Protect against viruses and malware",
      "Set up VPN for remote work",
      "Prevent data leakage",
      "Real-time network monitoring",
    ],
    problemsTitle: "Common network problems",
    cards: [
      { title: "Slow internet", desc: "An unstable network slows down work." },
      { title: "Frequent outages", desc: "Unstable network affects business." },
      { title: "Security attacks", desc: "No protection such as a firewall." },
      { title: "Data insecurity", desc: "At risk of hacking or data leaks." },
    ],
    ctaTitle: "Need a secure network system?",
    ctaText: "Talk to our experts to design the right system for your business.",
    ctaContactText: "Contact us for support",
    
  },
};
export default translations;